import { memo } from "react";
import { useTranslation } from "react-i18next";
import { User } from "../../types/Types";
import { getConnectionMembershipDisplay } from "../../utils/connectionUserUtils";
import {
  ProfileField,
  ProfileSection,
  profileValue,
} from "./ProfileModalFields";

interface ProfileModalBusinessDetailsProps {
  selectedUser: User;
  isConnected?: boolean;
}

function ProfileModalBusinessDetails({
  selectedUser,
  isConnected,
}: ProfileModalBusinessDetailsProps) {
  const { t } = useTranslation();
  const np = () => t("profile.notProvidedYet");

  if (!isConnected) {
    return (
      <div className="px-3 pb-3 d-md-none">
        <ProfileSection title={t("profile.section.businessDetails")}>
          <ProfileField
            label={t("profile.label.businessName")}
            value={profileValue(selectedUser.businessName, np())}
          />
        </ProfileSection>
      </div>
    );
  }

  const website = selectedUser.businessWebsiteUrl?.trim();
  const membership =
    getConnectionMembershipDisplay(selectedUser) ||
    selectedUser.membershipName;

  return (
    <div className="px-3 pb-3">
      <ProfileSection title={t("profile.section.businessDetails")}>
        <ProfileField
          label={t("profile.label.businessName")}
          value={profileValue(selectedUser.businessName, np())}
        />
        <ProfileField
          label={t("profile.label.sectorIndustry")}
          value={profileValue(selectedUser.businessSectorIndustry, np())}
        />
        <ProfileField
          label={t("profile.label.countriesOperation")}
          value={profileValue(selectedUser.businessCountryOperation, np())}
        />
        <ProfileField
          label={t("profile.label.aboutBusiness")}
          value={profileValue(selectedUser.businessAbout, np())}
          fullWidth
        />
        <ProfileField
          label={t("profile.label.websiteUrl")}
          value={
            website ? (
              <a
                href={website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-truncate d-block"
                title={website}
              >
                {website}
              </a>
            ) : (
              np()
            )
          }
        />
        <ProfileField
          label={t("profile.label.objectives")}
          value={profileValue(selectedUser.businessObjectives, np())}
          fullWidth
        />
        <ProfileField
          label={t("profile.label.membershipTypeCap")}
          value={profileValue(membership, np())}
        />
      </ProfileSection>

      <ProfileSection title={t("profile.section.discounts")}>
        <ProfileField
          label={t("profile.label.productsServices")}
          value={profileValue(selectedUser.businessProductServices, np())}
        />
        <ProfileField
          label={t("profile.label.discountsPlatform")}
          value={profileValue(selectedUser.businessDiscount, np())}
        />
      </ProfileSection>
    </div>
  );
}

export default memo(ProfileModalBusinessDetails);
